import React, { useContext ,useState} from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Link, NavLink, useLocation } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";
import LoginButton from "../../Login/loginButton";
import Box from "@material-ui/core/Box";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import { WebContext } from "../../../../Utility";
import { NAVBAR_EXTERNAL_LINKS } from "../../../../Constants";
import { DesktopMenuDropdown } from "../mobileNavbar";

const useStyles = makeStyles((theme) => ({
  navbar: {
    height: 80,
    width: "100%",
    background: "transparent !important",
    zIndex: 1400,
  },
  navbarTransparentBg: {
    background: "transparent",
  },
  navbarColorNonTransparent: {
    background: "transparent",
  },
  navLink: {
    height: "inherit",
    color: theme.agentTheme.primary.foreground,
  },
  navBarContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    height: "inherit",
    [theme.breakpoints.down("sm")]: {
      alignItems: "center",
    },
  },
  navBarLogo: {
    margin: "auto 0px",
    "& img": {
      width: "100%",
      objectFit: "contain",
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: "50%",
    },
  },
  navBarContent: {
    display: "flex",
    flexDirection: "row",
    marginTop:'0.3rem'
  },
  navBarText: {
    padding: 5,
    color: theme.agentTheme.card.link_foreground,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  navBarTextContainer: {
    marginRight: 20,
    cursor: "pointer",
    display: "flex",
    alignItems: "flex-end",
    paddingBottom: 10,
    height: "100%",
  },
  navbarColorTransparent: {
    color: "white",
    "&$activeNavItem": {
      color: theme.agentTheme.secondary.main,
    },
    "&:hover": {
      color: theme.agentTheme.secondary.main,
    },
  },
  navbarLinkNonTransparent: {
    color: theme.agentTheme.primary.foreground,
    "&$activeNavItem": {
      color: theme.agentTheme.secondary.main,
    },
    "&:hover": {
      color: theme.agentTheme.secondary.main,
    },
  },
  navIcon: {
    margin: "auto 0px",
    color: theme.agentTheme.primary?.main,
    zIndex: 1,
  },
  navIconTransparent: {
  color: theme.agentTheme.primary.main,
  },
  navIconNonTransparent: {
    color: theme.agentTheme.primary.foreground,
  },
  activeNavItem: {
    backgroundColor: theme.agentTheme.primary.main,
    color: theme.agentTheme.primary.foreground,
  },
  activeMobileItem: {
    color: theme.agentTheme.primary.main,
  },
  loginButtonTransparent: {
    marginTop: "25px",
    color: theme.agentTheme.primary.main,
    borderColor: theme.agentTheme.primary.main,
    [theme.breakpoints.down("sm")]: {
      marginTop: "0px",
    },
  },
  loginButtonNonTransparent: {
    marginTop: "25px",
    color: theme.agentTheme.primary.main,
    borderColor: theme.agentTheme.primary.main,
    [theme.breakpoints.down("sm")]: {
      marginTop: "0px",
    },
  },
}));

export default (props) => {
  let {
    logo_url = "",
    contentArr = [],
    username = "",
    getLogoUrl,
    isMobile = false,
    toggleMenu: mobileNavBarOpen = false,
    memberProfile,
    onNavIconClick,
    nonTransparentNav = false,
      handleCovidMenuClose,
    handleCovidMenuItemClick,
    loginItem,
  } = props || {};
  const classes = useStyles();
  const location = useLocation();
  const { isLoggedIn = false } = useContext(WebContext);
 const [isLoginMenu, setIsLoginMenu] = useState(false);
   const [anchorEl, setAnchorEl] = useState(null);
     const [clickItem, setClickItem] = useState([]);
       const handleCovidMenuClick = (
    event,
    clickItemParam = [],
    islogin = false
  ) => {
    setIsLoginMenu(islogin);
    if (clickItemParam.length > 0) setClickItem(clickItemParam);
    if (anchorEl == null) setAnchorEl(event.currentTarget);
    else handleCovidMenuClose();
  };
  const getNavItem = () => {
    return (
      <>
        {contentArr.map((item) => {
          let showActive = false;
          if (location.pathname == item.link) showActive = true;
          else if (location.pathname == "/" && item.link == `/${username}`)
            showActive = true;
          else if (item.clickHandle) {
            item.clickItem.map((element) => {
              if (
                element.link == location.pathname ||
                element.link.pathname == location.pathname
              )
                showActive = true;
            });
          }
          if (mobileNavBarOpen) {
          } else {
            if (item.clickHandle) {
              return (
                <>
                  <div
                    className={`${classes.navTextHover} ${
                      nonTransparentNav
                        ? classes.navbarLinkNonTransparent
                        : classes.navbarColorTransparent
                    } ${classes.navBarTextContainer} ${
                      showActive && classes.activeNavItem
                    } ${classes.navLink}`}
                    onClick={(e) => handleCovidMenuClick(e, item.clickItem)}
                  >
                    <Typography
                      variant="h6"
                      noWrap={true}
                      className={classes.navBarText}
                    >
                      {item.label} {item.dropdown && <KeyboardArrowDown />}
                    </Typography>
                  </div>
                </>
              );
            } else {
              const isExternalLink = NAVBAR_EXTERNAL_LINKS.includes(
                item.label.toLowerCase()
              );
              return isExternalLink ? (
                <a href={item.link}>
                  <div
                    className={`${classes.navBarTextHover} ${
                      nonTransparentNav
                        ? classes.navbarLinkNonTransparent
                        : classes.navbarColorTransparent
                    } ${classes.navBarTextContainer} ${
                      showActive && classes.activeNavItem
                    }`}
                  >
                    <Typography
                      variant="h6"
                      noWrap={true}
                      className={classes.navBarText}
                    >
                      {item.label}
                    </Typography>
                  </div>
                </a>
              ) : (
                <NavLink
                  to={{
                    pathname: item.link,
                    hash: item.hash || "",
                    state: { memberProfileData: memberProfile },
                  }}
                >
                  <div
                    className={`${classes.navBarTextHover} ${
                      nonTransparentNav
                        ? classes.navbarLinkNonTransparent
                        : classes.navbarColorTransparent
                    } ${classes.navBarTextContainer} ${
                      showActive && classes.activeNavItem
                    }`}
                  >
                    <Typography
                      variant="h6"
                      noWrap={true}
                      className={classes.navBarText}
                    >
                      {item.label}
                    </Typography>
                  </div>
                </NavLink>
              );
            }
          }
        })}
      </>
    );
  };

  return (
    <div
      id="navbar_container"
      className={`${classes.navbar} ${
        nonTransparentNav
          ? classes.navbarColorNonTransparent
          : classes.navbarTransparentBg
      }`}
    >
      <Container maxWidth={false} className={classes.navBarContainer}>
        <div className={classes.navBarLogo}>
          {isMobile && (
            <div
              className={`${classes.navIcon} ${
                !mobileNavBarOpen &&
                `${
                  nonTransparentNav
                    ? classes.navIconNonTransparent
                    : classes.navIconTransparent
                }`
              }`}
            >
              {!mobileNavBarOpen ? (
                <MenuIcon onClick={onNavIconClick} />
              ) : (
                <CloseIcon onClick={onNavIconClick} />
              )}
            </div>
          )}
          {!isMobile && logo_url && (
            <Link to={`/${username ? `${username}` : ""}`}>
              <img src={getLogoUrl(logo_url)} height="70" />
            </Link>
          )}
        </div>
        {isMobile && logo_url && (
          <Link to={`/${username ? `${username}` : ""}`}>
            <img src={getLogoUrl(logo_url)} height="70" />
          </Link>
        )}
        {isMobile && (
          <LoginButton
            loginClass={
              nonTransparentNav
                ? classes.loginButtonTransparent
                : classes.loginButtonNonTransparent
            }
          />
        )}
        {!isMobile && (
          <div className={classes.navBarContent}>
            {getNavItem()}
            {!isMobile && (
              <Box
                onClick={(e) => isLoggedIn && handleCovidMenuClick(e, [], true)}
              >
                <LoginButton
                  loginClass={
                    nonTransparentNav
                      ? classes.loginButtonTransparent
                      : classes.loginButtonNonTransparent
                  }
                />
              </Box>
            )}
          </div>
        )}
      </Container>
       {(isLoginMenu || clickItem.length > 0) && (
                    <DesktopMenuDropdown
                      anchorEl={anchorEl}
                      handleCovidMenuClose={handleCovidMenuClose}
                      loginMenu={isLoginMenu}
                      clickItem={isLoginMenu ? loginItem : clickItem}
                      handleCovidMenuItemClick={handleCovidMenuItemClick}
                    />
                  )}
    </div>
  );
};
